const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const user = state => {
  if (state.user.info.code === '10000') {
    return state.user
  } else {
    try {
      return {
        info: localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).info, permissions: localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).permissions
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export { toggleWithoutAnimation, config, palette, isLoading, user }
